import styled from 'styled-components'

import { ResponsiveImage, TypeStyle, fromMd } from '@syconium/little-miss-figgy'

export const Body = styled.div`
  display: flex;
  flex-direction: row;
  color: ${o => o.theme.color.deprecated.obsidian};
`

export const ImageWrapper = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  aspect-ratio: 175 / 227;
  height: auto;
  width: 175px;
  max-width: 25%;
`

export const Image = styled(ResponsiveImage)`
  display: block;
  width: 100%;
  object-fit: cover;
`

export const Content = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  flex-direction: column;
  margin-inline-start: ${props => props.theme.spacing(4)};

  ${fromMd} {
    margin-inline-start: ${props => props.theme.spacing(6)};
  }
`

export const Title = styled.span`
  ${TypeStyle.css.headlineExtraSmall}
  color: ${o => o.theme.color.deprecated.obsidian};
`
